// mixpanelHelper.ts

declare const mixpanel: any;

/**
 * Helper function to track CTA clicks in Mixpanel.
 * @param {string} element - The type of element clicked (e.g., "link", "button").
 * @param {string} text - The text/content of the element clicked.
 */

const toSnakeCase = (str: string): string =>
  str?.replace(/\s+/g, "_").toLowerCase();

// Helper function to convert camelCase to snake_case
const camelToSnake = (str: string): string => {
  return str?.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

// Main function to flatten the object and convert keys to snake_case
const flattenAndConvertObject = (obj: any): any => {
  const visited = new WeakSet();

  function flatten(currentObj: any): any {
    if (Array.isArray(currentObj)) {
      // Skip if it's an array
      return undefined;
    }

    if (typeof currentObj !== "object" || currentObj === null) {
      // Return the value as is if it's not an object or array
      return currentObj;
    }

    if (visited.has(currentObj)) {
      // Circular reference detected, skip this object
      return undefined;
    }

    visited.add(currentObj);

    const newObj: any = {};

    for (const key in currentObj) {
      if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
        // Convert the current key to snake_case
        const snakeKey = camelToSnake(key);

        // If the value is a nested object, flatten it
        if (
          typeof currentObj[key] === "object" &&
          !Array.isArray(currentObj[key])
        ) {
          const nestedObj = flatten(currentObj[key]);
          // Merge the nested object with the new object
          if (nestedObj) {
            for (const nestedKey in nestedObj) {
              if (Object.prototype.hasOwnProperty.call(nestedObj, nestedKey)) {
                // Merge nested keys to the top level with snake_case
                newObj[nestedKey] = nestedObj[nestedKey];
              }
            }
          }
        } else {
          // For non-object values, just assign them
          newObj[snakeKey] = currentObj[key];
        }
      }
    }

    return newObj;
  }

  return flatten(obj);
};
//Trade functions Strats from here

export interface TableRow {
  asset_group_search_payload: string; // AGSP
  asset_group_search: string; // AGS
  asset_group_navigation: string; // AGN
  asset_group_navigation_url: string; // AGNU
  asset_group_database: string; // AGD
  section_name: string; // SN
}

export interface TableRow {
  asset_group_search_payload: string; // AGSP
  asset_group_search: string; // AGS
  asset_group_navigation: string; // AGN
  asset_group_navigation_url: string; // AGNU
  asset_group_database: string; // AGD
  section_name: string; // SN
}

export const tableData: TableRow[] = [
  {
    asset_group_search_payload: "Equity",
    asset_group_search: "EQ",
    asset_group_navigation: "Equity",
    asset_group_navigation_url: "equity",
    asset_group_database: "EQUITY",
    section_name: "equity",
  },
  {
    asset_group_search_payload: "Future",
    asset_group_search: "FUT",
    asset_group_navigation: "Futures",
    asset_group_navigation_url: "futures",
    asset_group_database: "FUTURES",
    section_name: "futures",
  },
  {
    asset_group_search_payload: "Option",
    asset_group_search: "OPT",
    asset_group_navigation: "Options",
    asset_group_navigation_url: "options",
    asset_group_database: "OPTIONS",
    section_name: "options",
  },
  {
    asset_group_search_payload: "MF",
    asset_group_search: "MF",
    asset_group_navigation: "Mutual Funds",
    asset_group_navigation_url: "mutualFunds",
    asset_group_database: "MUTUAL FUNDS",
    section_name: "mutualFunds",
  },
  {
    asset_group_search_payload: "ETFs",
    asset_group_search: "ETF",
    asset_group_navigation: "Exchange-traded funds (ETFs)",
    asset_group_navigation_url: "etfs",
    asset_group_database: "ETFS",
    section_name: "etfs",
  },
  {
    asset_group_search_payload: "NcdSecondary",
    asset_group_search: "NCD",
    asset_group_navigation: "NCD",
    asset_group_navigation_url: "ncds",
    asset_group_database: "NCD",
    section_name: "ncds",
  },
  {
    asset_group_search_payload: "ipo",
    asset_group_search: "PRIMARY MRK",
    asset_group_navigation: "Initial Public Offer (IPO)",
    asset_group_navigation_url: "ipo",
    asset_group_database: "IPO",
    section_name: "ipo",
  },
  {
    asset_group_search_payload: "ncd-ipo",
    asset_group_search: "PRIMARY MRK",
    asset_group_navigation: "NCD IPO",
    asset_group_navigation_url: "ncd-ipo",
    asset_group_database: "NCD IPO",
    section_name: "ncd-ipo",
  },
  {
    asset_group_search_payload: "nfo",
    asset_group_search: "PRIMARY MRK",
    asset_group_navigation: "New Fund Offer (NFO)",
    asset_group_navigation_url: "nfo",
    asset_group_database: "NFO",
    section_name: "nfo",
  },
  {
    asset_group_search_payload: "Indices",
    asset_group_search: "INDICES",
    asset_group_navigation: "Indices",
    asset_group_navigation_url: "INDEX",
    asset_group_database: "INDICES",
    section_name: "XXXXXXXXX",
  },
  {
    asset_group_search_payload: "CURFUT",
    asset_group_search: "CURFUT",
    asset_group_navigation: "Currency Futures",
    asset_group_navigation_url: "FUTCUR",
    asset_group_database: "CURRENCY FUTURES",
    section_name: "XXXXXXXXX",
  },
  {
    asset_group_search_payload: "CUROPT",
    asset_group_search: "CUROPT",
    asset_group_navigation: "Currency Options",
    asset_group_navigation_url: "OPTCUR",
    asset_group_database: "CURRENCY OPTIONS",
    section_name: "XXXXXXXXX",
  },
  {
    asset_group_search_payload: "COMFUT",
    asset_group_search: "COMFUT",
    asset_group_navigation: "Commodity Futures",
    asset_group_navigation_url: "FUTCOM",
    asset_group_database: "COMMODITY FUTURES",
    section_name: "XXXXXXXXX",
  },
  {
    asset_group_search_payload: "COMOPT",
    asset_group_search: "COMOPT",
    asset_group_navigation: "Commodity Options",
    asset_group_navigation_url: "OPTCOM",
    asset_group_database: "COMMODITY OPTIONS",
    section_name: "XXXXXXXXX",
  },
];

function getRowObject(
  tableData: TableRow[],
  TS: "navbar" | "search",
  value: string,
): TableRow | null {
  const row = tableData.find((r) => {
    if (TS === "navbar") {
      return r.section_name === value;
    } else if (TS === "search") {
      return r.asset_group_search_payload === value;
    }
    return false;
  });

  return row || null;
}

export const registerTradeSuperProps = (
  rowData: any,
  assetType: any,
  searchKey: any,
  obj?: any,
) => {
  const name_desc = obj.name_desc;
  const display_name = obj.display_name;
  const exchange = obj.exchange;
  const symbol = obj.symbol;
  const trd_sym = obj.trd_sym;

  const queryParams = Object.fromEntries(
    Array.from(new URLSearchParams(window.location.search).entries()).map(
      ([key, value]) => [toSnakeCase(key), value],
    ),
  );

  mixpanel.register({
    asset_group_search_payload: rowData?.asset_group_search_payload,
    asset_group_navigation_url: rowData?.asset_group_navigation_url,
    trade_source: searchKey,
    asset_class: assetType,
    page_name: window.location.pathname,
    section_name: window.location.pathname.split("/").pop() || "unknown",
    asset_group_search: rowData?.asset_group_search,
    asset_group_navigation: rowData?.asset_group_navigation,
    asset_group_database: rowData?.asset_group_database,
    action: "click",
    name_desc,
    display_name,
    exchange,
    symbol,
    trd_sym,
    ...queryParams, // ← automatically added snake_case query params
  });
};

export const clearTradeSuperProps = () => {
  localStorage.setItem("trade_initiated_pending", "true");
  [
    "asset_group_search_payload",
    "asset_group_navigation_url",
    "trade_source",
    "asset_class",
    "page_name",
    "section_name",
    "asset_group_search",
    "asset_group_navigation",
    "asset_group_database",
    "action",
    // Clear newly added ones 👇
    "name_desc",
    "display_name",
    "exchange",
    "symbol",
    "trd_sym",
  ].forEach((key) => mixpanel.unregister(key));
};

export const getUrlInfo = () => {
  const url = new URL(window.location.href);

  // Section name → last part of pathname
  const pathParts = url.pathname.split("/").filter(Boolean);
  const sectionName = pathParts.length
    ? pathParts[pathParts.length - 1]
    : "unknown";

  // Convert URL parameters into an object
  const queryParams: Record<string, string> = {};
  url.searchParams.forEach((value, key) => {
    queryParams[key] = value;
  });

  return {
    sectionName,
    queryParams,
  };
};

export const transactionleadinitiated = (props: any) => {
  const result = flattenAndConvertObject(props);
  const assetType = result?.as_typ || result?.asset_type;
  const search_key = localStorage.getItem("search_key");
  const { sectionName, queryParams } = getUrlInfo();
  let rowData: TableRow | null = null;
  if (search_key) {
    rowData = getRowObject(tableData, "search", search_key);
  } else {
    const parts = window.location.pathname.split("/").filter(Boolean);
    const candidates = [];

    // Collect non-numeric segments from the end
    while (parts.length > 0) {
      const candidate = parts.pop();
      if (isNaN(Number(candidate))) {
        candidates.push(candidate);
      }
      if (candidates.length === 3) break; // Limit to last 3 non-numeric segments
    }

    let lastSegment = "unknown";
    for (const candidate of candidates) {
      const data = getRowObject(tableData, "navbar", candidate);
      if (data) {
        rowData = data;
        break;
      }
    }
  }
  // Fallback: Try matching assetType to asset_group_search via prefix
  if (!rowData && assetType) {
    // Check if assetType is Lumpsum or SIP
    const searchType =
      assetType.toUpperCase() === "LUMPSUM" || assetType.toUpperCase() === "SIP"
        ? "MF"
        : assetType;

    rowData =
      tableData.find((r) =>
        searchType
          .toUpperCase()
          .startsWith(r.asset_group_search_payload.toUpperCase()),
      ) || null;
  }
  const obj = {
    name_desc: props?.name_desc ? props?.name_desc : "",
    display_name: props?.display_name ? props?.display_name : "",
    exchange: props?.exchange ? props?.exchange : "",
    symbol: props?.symbol ? props?.symbol : "",
    trd_sym: props?.trd_sym ? props?.trd_sym : "",
  };
  // Register as super properties (shared across next events)
  registerTradeSuperProps(rowData, assetType, search_key, obj);
  // Fire the first event
  mixpanel.track("trade_initiated", {
    component: sectionName,
    ...queryParams,
    ...result,
    timestamp: new Date().toISOString(),
  });
  localStorage.setItem("trade_initiated_pending", "false");
};

export const trackplaceorders = () => {
  mixpanel.track("trade_place_order", {
    timestamp: new Date().toISOString(),
  });
};

export const transactionleadconfirm = (props: any) => {
  const result = flattenAndConvertObject(props);
  const { sectionName, queryParams } = getUrlInfo();
  mixpanel.track("trade_confirm_order", {
    ...result,
    component: sectionName,
    ...queryParams,
    timestamp: new Date().toISOString(),
  });
};

export const transactionleadcancel = (props: any) => {
  const result = flattenAndConvertObject(props);
  const { sectionName, queryParams } = getUrlInfo();
  mixpanel.track("trade_cancelled", {
    ...result,
    component: sectionName,
    ...queryParams,
    timestamp: new Date().toISOString(),
  });

  // Clear super properties so they don't affect new trades
  clearTradeSuperProps();
};

export const transactionleadsuccess = (props: any) => {
  const result = flattenAndConvertObject(props);
  const { sectionName, queryParams } = getUrlInfo();
  mixpanel.track("trade_successful", {
    ...result,
    component: sectionName,
    ...queryParams,
    timestamp: new Date().toISOString(),
  });

  clearTradeSuperProps();
};

export const transactionleadfail = (props: any) => {
  const result = flattenAndConvertObject(props);
  const { sectionName, queryParams } = getUrlInfo();
  mixpanel.track("trade_failure", {
    ...result,
    component: sectionName,
    ...queryParams,
    timestamp: new Date().toISOString(),
  });
  clearTradeSuperProps();
};
// Trade functions ended here

//lead function started here
export const formleadinitiated = (props: object) => {
  const result = flattenAndConvertObject(props);
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  clearTradeSuperProps();
  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1]; // Always take the segment after "products"
  }

  mixpanel.track("lead_initiated", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    section_name: window.location.pathname.split("/").pop() || "unknown", // Extract section name from URL
    timestamp: new Date().toISOString(), // Timestamp of the click
    class_name: sectionName,
  });
};

export const formleadpresent = (props: object) => {
  const result = flattenAndConvertObject(props);
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  clearTradeSuperProps();
  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1]; // Always take the segment after "products"
  }

  mixpanel.track("lead_present", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    section_name: window.location.pathname.split("/").pop() || "unknown", // Extract section name from URL
    timestamp: new Date().toISOString(), // Timestamp of the click
    class_name: sectionName,
  });
};

export const formleaderror = (props: object) => {
  const result = flattenAndConvertObject(props);
  const userId = localStorage.getItem("userId");
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  clearTradeSuperProps();
  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1]; // Always take the segment after "products"
  }

  mixpanel.track("lead_error", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    section_name: window.location.pathname.split("/").pop() || "unknown", // Extract section name from URL
    timestamp: new Date().toISOString(), // Timestamp of the click
    class_name: sectionName,
  });
};

export const formleadcancel = (props = {}, step = "cancel_1") => {
  const result = flattenAndConvertObject(props);
  clearTradeSuperProps();
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");

  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1];
  }

  mixpanel.track("lead_cancel", {
    ...result,
    page_name: window.location.pathname,
    section_name: pathParts.pop() || "unknown",
    lead_type: "product",
    timestamp: new Date().toISOString(),
    class_name: sectionName,
    step: step, // Step where lead was cancelled
  });
};

export const userfound = (props = {}) => {
  const result = flattenAndConvertObject(props);
  clearTradeSuperProps();
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");

  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1];
  }

  mixpanel.track("user_found", {
    ...result,
    page_name: window.location.pathname,
    section_name: pathParts.pop() || "unknown",
    lead_type: "product",
    timestamp: new Date().toISOString(),
    class_name: sectionName,
  });
};

export const formleadcomplete = (props: object) => {
  const userId = localStorage.getItem("userId");
  const result = flattenAndConvertObject(props);
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const productsIndex = pathParts.indexOf("products");
  clearTradeSuperProps();
  let sectionName = "unknown";
  if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
    sectionName = pathParts[productsIndex + 1]; // Always take the segment after "products"
  }
  mixpanel.track("lead_completed", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    section_name: window.location.pathname.split("/").pop() || "unknown", // Extract section name from URL
    timestamp: new Date().toISOString(), // Timestamp of the click
    status: userId ? "logged in" : "logged out", // ✅ Dynamically set based on userId
    class_name: sectionName,
  });
};

//Lead functions endede here

export const trackCtaClick = (
  element: string,
  text: string,
  action: string,
) => {
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("cta_clicked", {
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL

    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    action: action,
  });
};

export const trackCtaClicks = (
  element: string,
  text: string,
  action: string,
  component: string,
) => {
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  try {
    mixpanel.track("cta_clicked", {
      page_name: window.location.pathname, // Track the current page path
      timestamp: new Date().toISOString(), // Timestamp of the click event
      section_name: sectionName, // Add the section name based on the URL

      element: element, // Track the element type (e.g., "link", "button")
      text: text, // Track the text of the clicked element
      action: action,
      component: component,
    });
  } catch (error) {
    return;
  }
};

export const trackiconClic = (element: string, text: any, action: string) => {
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  clearTradeSuperProps();
  mixpanel.track("icon_clicked", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action,
  });
};

export const trackIconClick = (title: string, iconType: string | number) => {
  clearTradeSuperProps();
  const eventName = toSnakeCase(title); // ➜ "add_alert", "add_to_watchlist"
  const sectionName = window.location.pathname.split("/").pop() || "unknown";
  const storedDataString = localStorage.getItem("last_viewed_stock_data");
  const storedData = storedDataString ? JSON.parse(storedDataString) : {};
  delete storedData.bar_graph_data;
  delete storedData.data;
  delete storedData.datalist;
  delete storedData.optio_chain;

  mixpanel.track(eventName, {
    ...storedData,
    title,
    icon_type: iconType,
    page_name: window.location.pathname,
    section_name: sectionName,
    timestamp: new Date().toISOString(),
  });
};

export const TabSleceted = (element: string, text: string, action: string) => {
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  clearTradeSuperProps();
  mixpanel.track("tab_selected", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action, // Add the action (tab_selected in this case)
  });
};

export const DropDownSelected = (
  element: string,
  text: string,
  action: string,
) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("dropdown_selected", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action, // Add the action (tab_selected in this case)
  });
};

export const DropDownOpen = (element: string, text: string, action: string) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("dropdown_clicked", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action, // Add the action (tab_selected in this case)
  });
};

export const loginSuccess = (
  userId: string,
  acctyp: string,
  method: string,
) => {
  clearTradeSuperProps();
  const sectionName = window.location.pathname.split("/").pop() || "unknown";
  mixpanel.track("login_successful", {
    user_id: userId,
    account_type: acctyp,
    login_method: method,

    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
  });
  mixpanel.register({
    user_status: "logged in",
  });

  // People profile
  mixpanel.people.set({
    user_status: "logged in",
    last_loggedin: new Date().toISOString(),
  });

  localStorage.setItem("trade_initiated_pending", "true");
  localStorage.setItem("userId", userId);
  localStorage.setItem("trade_initiated_pending", "true");
};

export const loginIntiated = (accType: string, flowChoosed: string) => {
  clearTradeSuperProps();
  const sectionName = window.location.pathname.split("/").pop() || "unknown";
  mixpanel.track("login_initiated", {
    account_type: accType,
    login_method: flowChoosed || "password",

    timestamp: new Date().toISOString(),
    page_name: window.location.pathname, // Track the current page path
    section_name: sectionName, // Add the section name based on the URL
  });
};
export const otpvalidation = (Res: Object) => {
  clearTradeSuperProps();
  const sectionName = window.location.pathname.split("/").pop() || "unknown";
  mixpanel.track("otp_validation", {
    ...Res,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const logoutIntiated = () => {};

export const logoutSuccess = () => {
  // Update People Profile – correct place for user_status
  mixpanel.people.set({
    user_status: "logged out",
    last_loggedout: new Date().toISOString(),
  });

  const sectionName = window.location.pathname.split("/").pop() || "unknown";

  // Event tracking
  mixpanel.track("logged_out_success", {
    page_name: window.location.pathname,
    timestamp: new Date().toISOString(),
    section_name: sectionName,
    user_status: "logged out", // Add in event for analysis
  });

  localStorage.removeItem("uniqueId");
  clearTradeSuperProps();

  // After all tracking is done, reset identity
  mixpanel.reset();
};

export const navbarclicked = (name: string, link: string) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  const parentNodeName = localStorage.getItem("parentNodeName") || "No Parent"; // Default to "No Parent" if not found
  const middlenode = localStorage.getItem("middlenode") || "No moddile node"; // Default to "No Parent" if not found
  localStorage.setItem("search_key", "navbar");
  mixpanel.track("navbar_clicked", {
    node_name: name,
    node_link: link,
    node_type: "Link",
    parent_node_name: parentNodeName, // Add parent node
    middle_node: middlenode,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
  localStorage.removeItem("search_key");
};

export const stockviwed = (props: object, name: string) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  const result = flattenAndConvertObject(props);
  localStorage.setItem("last_viewed_stock_data", JSON.stringify(result));
  mixpanel.track(`${name}_viewed`, {
    ...result, // ⬅️ Pass the entire stock record
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
    page_name: window.location.pathname,
  });
};

export const viewall = (props: any) => {
  clearTradeSuperProps();
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("view_all/more_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
    ...result,
  });
};

// Function to track sorting events
export const trackSortingEvent = (sortField: any, eventType: string) => {
  const result = flattenAndConvertObject(sortField);
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("view_all/more_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
    ...result,
    event_type: eventType,
  });
};

// Function to track filter events
export const trackFilterEvent = (
  filterField: string,
  filterValue: string,
  eventType: string,
) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("view_all/more_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
    event_type: eventType,
    filter_field: filterField,
    filter_value: filterValue,
  });
};

export const knowmore = () => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("know_more_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
    text: "know more",
  });
};

export const share = () => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("share_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
    //shareparent_class: props
  });
};

export const info = () => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("info_clicked", {
    page_name: window.location.pathname,
    section_name: sectionName, // Add the section name based on the URL
    timestamp: new Date().toISOString(),
  });
};

export const hyperlink = (element: string, text: string, action: string) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("hyperlink_clicked", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action,
  });
};

export const trackSearchInitiated = (symbol: string, assettype: string) => {
  // Extract the section name from the URL (after the last `/`)
  clearTradeSuperProps();
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  if (assettype) {
    localStorage.setItem("search_key", "search");
  }
  // Track search success
  mixpanel.track("search_result_clicked", {
    page_name: window.location.pathname, // Track the current page path
    query: symbol, // Assuming the symbol is a relevant indicator for the search success
    asset_type: assettype,
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const trackSearchfooterInitiated = (mobile_number: string) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  // Track search success
  mixpanel.track("search_footer_clicked", {
    page_name: window.location.pathname, // Track the current page path
    mobile_number: mobile_number, // Assuming the symbol is a relevant indicator for the search success
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const margincalculator = (result: object) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const results = flattenAndConvertObject(result);
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("margin_calculated", {
    ...results,
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
    page_name: window.location.pathname, // Track the current page path
  });
};
export const loginSuccesss = (method: string, register: object) => {
  clearTradeSuperProps();
  const sectionName = window.location.pathname.split("/").pop() || "unknown";
  mixpanel.track("login_successful", {
    login_method: method,
    ...register,

    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
  });

  // Super props (persist across events)
  mixpanel.register({
    channel: "website",
    device_type: window.innerWidth > 768 ? "desktop" : "mweb",
    user_status: "logged in",
  });

  // People profile
  mixpanel.people.set({
    user_status: "logged in",
    ...register,
    last_loggedin: new Date().toISOString(),
  });

  localStorage.setItem("trade_initiated_pending", "true");
};

export const peopleintrested = (
  element: string,
  text: string,
  action: string,
  props: object,
) => {
  clearTradeSuperProps();
  // Extract the section name from the URL (after the last `/`)
  const result = flattenAndConvertObject(props);
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  mixpanel.track("intrested_people", {
    page_name: window.location.pathname, // Track the current page path
    element: element, // Track the element type (e.g., "link", "button")
    text: text, // Track the text of the clicked element
    timestamp: new Date().toISOString(), // Timestamp of the click event
    section_name: sectionName, // Add the section name based on the URL
    action: action,
    ...result, // Spread all props to track additional user details
  });
};

export const withdrawinitiated = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("withrdraw_initiated", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const withdrawcompleted = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("withrdraw_completed", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const addfundsinitiated = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("add_funds_initiated", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const addfundscompleted = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("add_funds_completed", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const accordion_item_clicked = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  delete result._accordion_array;
  mixpanel.track("accordion_item_clicked", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const piechart = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("pie_chart", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const graphclicked = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  delete result.stock_list;
  mixpanel.track("indices_clicked", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const trackIndicesChanges = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found
  delete result.stock_list;

  mixpanel.track("indices_clicked", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};

export const tableclicked = (props: object) => {
  const result = flattenAndConvertObject(props);
  // Extract the section name from the URL (after the last `/`)
  const sectionName = window.location.pathname.split("/").pop() || "unknown"; // Default to "unknown" if section is not found

  mixpanel.track("table_clicked", {
    ...result,
    page_name: window.location.pathname, // Track the current page path
    timestamp: new Date().toISOString(),
    section_name: sectionName, // Add the section name based on the URL
  });
};
